 document.addEventListener("DOMContentLoaded", function() {
    var variantSelectsElement1 = document.querySelector('variant-selects#variant-selects-template--21288271249751__featured_product_GhGFX4');
    // Selecting the element with ID "variant-selects-template--21288271413591__main"

    if (variantSelectsElement1) {
        variantSelectsElement1.classList.add("muz-variant-section");
        // Adding the class "muz-variant-section" to the element
    }
});

